function updateScheduledCartBanners() {
  const banners = document.querySelectorAll(
    '[data-cart-scheduled-banner]'
  );

  banners.forEach((banner) => {
    const startValue = banner.dataset.start;
    const endValue = banner.dataset.end;

    const startTime = startValue ? Date.parse(startValue) : null;
    const endTime = endValue ? Date.parse(endValue) : null;
    const now = Date.now();

    const startIsValid =
      startTime === null || !Number.isNaN(startTime);

    const endIsValid =
      endTime === null || !Number.isNaN(endTime);

    if (!startIsValid || !endIsValid) {
      banner.hidden = true;
      console.warn(
        'カートバナーの日時形式を確認してください。',
        {
          start: startValue,
          end: endValue
        }
      );
      return;
    }

    const hasStarted =
      startTime === null || now >= startTime;

    const hasNotEnded =
      endTime === null || now < endTime;

    banner.hidden = !(hasStarted && hasNotEnded);
  });
}

document.addEventListener(
  'DOMContentLoaded',
  updateScheduledCartBanners
);

document.addEventListener(
  'shopify:section:load',
  updateScheduledCartBanners
);

window.setInterval(
  updateScheduledCartBanners,
  60000
);